import type { ReactNode } from "react";
export const Kbd = ({ children }: { children: ReactNode }) => {
    return (
        <kbd tw="inline-flex gap-0.5 opacity-60 p-1 px-1 text-center align-baseline cursor-default select-none whitespace-nowrap text-[10px] leading-[110%] rounded-md">
            {children}
        </kbd>
    );
};
